export default __webpack_public_path__ + "static/media/bw_photos_tuscany-3.aa1f33fd.jpg";